export default __webpack_public_path__ + "70fc1d0e84ea2593968c3c3ac713fd5f.svg";